<template>
    <div class="ProductDetail">
        <RouteHeadAndCrumbs
            :backgroundImg="backgroundImg"
            :breadcrumbsInfo="breadcrumbsInfo"
        />
        <div class="product-desc-main-container">
            <div class="product-desc-container">
                <div class="desc-left-container">
                    <p class="desc-title">产品概述</p>
                    <p class="desc-content-text">
                        {{ productInfo.summary }}
                    </p>
                </div>
                <div class="desc-right-container">
                    <img :src="productInfo.summaryImgUrl" alt="" />
                </div>
            </div>
        </div>
        <div class="product-framework-container">
            <p>产品架构</p>
            <div class="product-framework-img-container">
                <img :src="productInfo.frameworkImgUrl" alt="" />
            </div>
        </div>
        <div
            class="product-function-container"
            :style="`background:url(${productFunctionAreaBackgroundImg}) no-repeat;background-size:cover;`"
        >
            <div class="product-function-shade-container"></div>
            <div class="product-function-text-container">
                <div class="product-function-left-text">
                    <div class="product-function-left-main-text">
                        <p class="area-title-text">核心优势</p>
                    </div>
                </div>
                <div class="product-function-right-text">
                    <template v-for="item in getProductList()">
                        <div :key="item.id" class="one-product-function-area">
                            <p class="one-product-function-title">
                                {{ item.title }}
                            </p>
                            <p class="one-product-function-desc ">
                                {{ item.desc }}
                            </p>
                        </div>
                    </template>
                   
                </div>
            </div>
        </div>
        <div class="product-application-scenarios-container">
            <p class="title-text">应用场景</p>
            <div class="scenarios-body-container">
                <template v-for="(item, index) in getProductSceneList()">
                    <div :key="item.id" class="one-scenario-container">
                        <div class="scenarios-left-container">
                            <img :src="item.url" alt="" />
                        </div>
                        <div class="scenarios-right-container">
                            <p class="one-scenario-title-text">
                                {{ item.title }}
                            </p>
                            <!-- <p class="one-scenario-desc-text">
                                {{ item.desc }}
                            </p> -->
                            <div v-html="item.desc" class="article-content one-scenario-desc-text"></div>
                            <p class="one-scenario-number-text">
                                <span class="large-number">{{
                                    index + 1
                                }}</span>
                                <span>/{{ getProductSceneList().length }}</span>
                            </p>
                        </div>
                    </div>
                </template>
                <!-- <div class="one-scenario-container">
                    <div class="scenarios-left-container">
                        <img src="../assets/images/scenario.png" alt="" />
                    </div>
                    <div class="scenarios-right-container">
                        <p class="one-scenario-title-text">应用场景案例标题</p>
                        <p class="one-scenario-desc-text">
                            应用场景案例标题描述描述描述描述描述描述描述描述描述描述描述描述述描述描述描述描述述描述描述描
                        </p>
                        <p class="one-scenario-number-text">
                            <span class="large-number">01</span>
                            <span>/03</span>
                        </p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import headImg from "../assets/images/66.png";

import functionBgImg from "../assets/images/joinUs.png";

import { ROUTEINFO } from "../utils/constant";

import { GETPRODUCTINFOBYID } from "../utils/uriList";

export default {
    mounted() {
        this.getProductInfoById();
    },
    data() {
        return {
            backgroundImg: headImg,
            breadcrumbsInfo: [
                {
                    routeName: ROUTEINFO.home.name,
                    routeLabel: "首页",
                    routeTo: {
                        path: ROUTEINFO.home.path,
                    },
                },
                {
                    routeName: ROUTEINFO.productService.name,
                    routeLabel: "产品与服务",
                    routeTo: {
                        path: ROUTEINFO.productService.path,
                    },
                },
                {
                    routeName: ROUTEINFO.productDetail.name,
                    routeLabel: "产品详情",
                },
            ],
            productFunctionAreaBackgroundImg: functionBgImg,
            productInfo: {},
        };
    },
    methods: {
        async getProductInfoById() {
            const response = await this.$http.get(GETPRODUCTINFOBYID, {
                params: {
                    id: this.$route.params.productId,
                },
            });
            if (response.data.code === 0) {
                this.productInfo = response.data.data;
            }
        },
        getProductList() {
            return this.productInfo.productFunction
                ? JSON.parse(this.productInfo.productFunction)
                : [];
        },
        getProductSceneList() {
            return this.productInfo.productScene
                ? JSON.parse(this.productInfo.productScene)
                : [];
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/views/ProductDetail.scss";
</style>
